import React, { Component } from "react";
import { Translation, withTranslation } from "react-i18next";
import Bounce from "react-reveal/Bounce";
import { toast } from "react-toastify";
import { SnippetDataQuery } from "../../constants/apiParams";
import apiCall, { METHOD } from "../../constants/baseUrl";
import { stringToHTML } from "../../util/utils";

class NumberDialogue extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      nestedSnippetData: {},
      content: {},
      number: 0,
      minValue: 0,
      maxValue: 0,
      hide_on_zero: false,
    };
  }


  handleLoader = status => {
    this.setState(() => {
      return {
        isLoading: status
      };
    });
  };


  close_text_dialogue = () => {
    const { hide_on_zero } = this.state;

    const {
      setDynamicValue,
      closeDialogue,
      reference, id
    } = this.props;

    if (hide_on_zero) {
      setDynamicValue(id, "");
      closeDialogue();
    } else {
      closeDialogue();
    }
  }


  componentDidMount() {
    const { id } = this.props;
    apiCall(
      METHOD.QUERY,
      SnippetDataQuery(id),
      data => {
        console.log("nestedApicall", data);

        let jsonContent = JSON.parse(data.content);
        this.setState({
          nestedSnippetData: data,
          content: jsonContent,
          minValue: jsonContent.min_value,
          maxValue: jsonContent.max_value,
          number: jsonContent.default,
          hide_on_zero: jsonContent.hide_on_zero,
          raw_value: JSON.parse(JSON.parse(data.raw_value)),

        });
      },
      isLoading => { },
      (data) => {
        toast.error(this.props.t(data.message));
      }
    );
  }

  onCounterClick = type => {

    const { minValue, maxValue } = this.state;
    if (type) {
      this.setState(prevState => {
        if (prevState.number !== maxValue) {
          return {
            ...this.state,
            number: prevState.number + 1
          };
        } else {
          toast.info(
            this.props.t("snippetDialogue.conditionDialogueValidation") +
            minValue +
            " - " +
            maxValue +
            "."
          );
        }
      });
    } else {
      this.setState(prevState => {
        if (prevState.number !== minValue) {
          return {
            ...this.state,
            number: prevState.number - 1
          };
        } else {
          toast.info(
            this.props.t("snippetDialogue.conditionDialogueValidation") +
            minValue +
            " - " +
            maxValue +
            "."
          );
        }
      });
    }
  };

  submitData = () => {
    const {
      setDynamicValue,
      setFinalDynamicValueWithInnerSnippet,
      closeDialogue,
      reference,
      id
    } = this.props;

    const {
      content,
      number,
      hide_on_zero,
      minValue,
      maxValue,
      raw_value
    } = this.state;

    if (minValue > number || number > maxValue) {
      toast.info(
        this.props.t("snippetDialogue.conditionDialogueValidation") +
        minValue +
        " - " +
        maxValue +
        "."
      );
    } else {
      let val = content.content;
      val = val.replace("<value>", number);

      if (val.includes("<refe")) {
        let innerReference = stringToHTML(val, Date.now());
        var children = innerReference.children;
        let referenceInSpan = children[0];

        referenceInSpan.onclick = (e) => {
          e.preventDefault();
          if (e.stopPropagation) e.stopPropagation();
          this.props.handleReferenceClick(referenceInSpan);
        };
        referenceInSpan.setAttribute(
          "class",
          "reference-backgroupred"
        );
        referenceInSpan.innerHTML = referenceInSpan.getAttribute(
          "placeholder"
        );
        console.log("referenceInSpan", innerReference);

        // val = innerReference;
        setFinalDynamicValueWithInnerSnippet(
          id,
          ""+number,
          raw_value
        );
      } else {

        let val1 = raw_value.blocks[0].text;
        let value_tag_position = val1.search("<value>")
        val1 = val1.replace("<value>", number);
        setDynamicValue(id, val1, raw_value, value_tag_position, number);


      }
      closeDialogue();
    }


  };

  render() {
    const { number, nestedSnippetData } = this.state;
    return (
      <Translation ns="translation">
        {(t, { i18n }) => {
          return (
            <Bounce bottom>
              <div
                className="navbar-collapse collapse text-left bottom-half2 show"
                id="Brand-toggler"
              >
                <div className="d-flex ">
                  <button
                    className="navbar-toggler icon-close mr-3 mt-3 w-100 text-right"
                    onClick={this.submitData}
                    type="button"
                    data-toggle="collapse"
                    data-target="#Brand-toggler"
                    aria-controls="Brand-toggler"
                    aria-expanded="true"
                    aria-label="Toggle navigation"
                  >
                    <i className="zmdi zmdi-save zmdi-hc-fw font-30"></i>
                  </button>

                  <button
                    className="navbar-toggler icon-close mr-3 mt-3 w-100 text-right"
                    onClick={() => {
                      this.close_text_dialogue();
                    }}
                    type="button"
                    data-toggle="collapse"
                    data-target="#Brand-toggler"
                    aria-controls="Brand-toggler"
                    aria-expanded="true"
                    aria-label="Toggle navigation"
                  >
                    <i className="zmdi zmdi-close zmdi-hc-fw font-30"></i>
                  </button>
                </div>

                <div className="text-center">
                  <p className="mt-4">
                    {nestedSnippetData.name && nestedSnippetData.name}
                  </p>

                  <div className="max-170 m-auto">
                    <div className="input-group mb-3">
                      <div
                        className="pointer input-group-append input-group-text font-20 bg-dark"
                        onClick={() => {
                          this.onCounterClick(false);
                        }}
                      >
                        <i className=" zmdi zmdi-minus zmdi-hc-fw text-light"></i>
                      </div>
                      <label className="form-control">{number}</label>
                      <div
                        className="pointer input-group-prepend input-group-text font-20 bg-dark"
                        onClick={() => {
                          this.onCounterClick(true);
                        }}
                      >
                        <i className="zmdi zmdi-plus zmdi-hc-fw text-light pointer"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Bounce>
          );
        }}
      </Translation>
    );
  }
}
export default withTranslation()(NumberDialogue);  